import React, { useEffect, useRef } from 'react';
import simpleheat from '../../../../components/simpleheat';
import silhouette from '../../../../images/orientation2.svg';

/**
 * Canvas heatmap of normalized artefact positions with grave contour
 * overlays and an optional body silhouette for left/right orientations.
 *
 * @param {Array<[number, number]>} artefacts normalized positions (0..1)
 * @param {Array<Array<[number, number]>>} graves normalized grave contours
 * @param {string} [orientation] 'left' | 'right' | 'site'
 * @param {number} [width=500]
 * @param {number} [height=700]
 */
export default function HeatmapCanvas({
  artefacts,
  graves,
  orientation,
  width = 500,
  height = 700
}) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const data = (artefacts || []).map(([x, y]) => [x * width, y * height, 1]);
    simpleheat(canvas)
      .data(data)
      .overlays(graves || [])
      .radius(15, 20)
      .draw();

    if (orientation === 'left' || orientation === 'right') {
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.src = silhouette;
      img.height = 200;
      img.width = 200;
      img.onload = () => {
        const canvasAspect = canvas.width / canvas.height;
        const imgAspect = img.width / img.height;

        let drawWidth;
        let drawHeight;
        let offsetX;
        let offsetY;
        if (imgAspect > canvasAspect) {
          drawWidth = canvas.width;
          drawHeight = canvas.width / imgAspect;
          offsetX = 0;
          offsetY = (canvas.height - drawHeight) / 2;
        } else {
          drawHeight = canvas.height;
          drawWidth = canvas.height * imgAspect;
          offsetX = (canvas.width - drawWidth) / 2;
          offsetY = 0;
        }

        ctx.save();
        if (orientation === 'left') {
          ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
        } else {
          ctx.translate(offsetX * 2 + drawWidth, 0);
          ctx.scale(-1, 1);
          ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
        }
        ctx.restore();
      };
    }
    return undefined;
  }, [artefacts, graves, orientation, width, height]);

  return (
    <div className="heatmap-wrap">
      <canvas ref={canvasRef} width={width} height={height} className="heatmap-canvas" />
    </div>
  );
}
